export default __webpack_public_path__ + "static/media/Oro-1.8cf4c574.png";